import React from "react"
import { createRoot } from "react-dom/client"
import ImpactCounter from "../../components/ImpactCounter"

// Mirrors the save-a-life-crm pattern: find a server-rendered mount node and
// hydrate a React island into it. Everything else on the page is plain,
// theme-styled ERB — React only owns this one interactive widget.
const el = document.getElementById("impact-counter-root")
if (el) {
  createRoot(el).render(<ImpactCounter />)
}
